import { pick, serverMap } from '@/shared/lib/server-map'
import type { MessageChannel } from '@/shared/api'

/**
 * Род канала доставки → цвет-точка бейджа на пузыре (и в выпадашке композитора). Лента брони
 * теперь МУЛЬТИканальная — одно сообщение пришло по WhatsApp, другое ботом, третье по SMS, — и
 * бейдж отличает их с одного взгляда. Сам ЛЕЙБЛ («WhatsApp», «Бот») отдаёт сервер в
 * `MessageChannel.label`; фронт выбирает только цвет по роду, как везде («сервер отдаёт смысл,
 * фронт — палитру»).
 *
 * Ключ карты — `string`, а не `MessageChannel['kind']`: род с сервера типом не гарантирован
 * (контракт расширят раньше фронта). Незнакомый род уезжает в серый через общую дверь `pick`,
 * а не роняет ленту. Токены — те же, что у мессенджеров в `model/messenger`, чтобы «мессенджер»
 * тут и плитка WhatsApp там читались одним цветом.
 */
const CHANNEL_KIND_TOKENS = serverMap({
  messenger: 'var(--st-confirmed)',
  bot: 'var(--violet)',
  sms: 'var(--st-noshow)',
  web: 'var(--st-pending)',
})

const FALLBACK_TOKEN = 'var(--ink-3)'

export function channelKindToken(kind: MessageChannel['kind'] | string): string {
  return pick(CHANNEL_KIND_TOKENS, kind, FALLBACK_TOKEN)
}
